export function initStonly(): void {
  const widgetId = import.meta.env.VITE_STONLY_WID
  if (!widgetId) return

  window.STONLY_WID = widgetId
  if (window.StonlyWidget) return

  // Stonly vendor initialization - dynamic function-object hybrid pattern
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Stonly SDK uses dynamic function-object hybrid pattern
  const w: any = (window.StonlyWidget = Object.assign(
    (...args: unknown[]) => {
      if (w._api) {
        w._api(...args)
      } else {
        w.queue.push(args)
      }
    },
    {
      _api: undefined as ((...args: unknown[]) => void) | undefined,
      scriptPath: 'https://stonly.com/js/widget/v2/',
      queue: [] as unknown[][],
    },
  ))

  const g = new XMLHttpRequest()
  g.open('GET', w.scriptPath + 'version?v=' + Date.now(), true)
  g.onreadystatechange = function () {
    if (g.readyState === 4) {
      const script = document.createElement('script')
      script.async = true
      script.src =
        w.scriptPath +
        'stonly-widget.js?v=' +
        (g.status === 200 ? g.responseText : Date.now())
      document.head.appendChild(script)
    }
  }
  g.send()
}
